export default new class Dropdown {
    constructor() {
        this.initHandler();
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.addEventListener("DOMContentLoaded", () => {
            this.selectInit();

            [].forEach.call(document.querySelectorAll('.select__header'), function selectHeader(el) {
                el.addEventListener('click', function selectHeaderEl(event) {
                    event.currentTarget.querySelector('.select__search').value = '';
                    event.currentTarget.querySelector('.select__search').focus();
                    if(event.target.closest('.select').classList.contains('is-search')) {
                        event.currentTarget.closest('.select').querySelector('.select__search-label').style.opacity = 1;
                        event.currentTarget.closest('.select').querySelector('.select__search-label').style.zIndex = 1;
                        event.currentTarget.closest('.select').querySelector('.select__current').style.opacity = 0;
                    }
                })
            });

            [].forEach.call(document.querySelectorAll('.select__search'), function selectSearch(item) {
                item.addEventListener('input', function selectHeaderEl(e) {
                    if(e.target.closest('.select').classList.contains('is-search')) {
                        const searchText = e.target.value;
                        // if(searchText.length > 0) {
                        //     e.currentTarget.closest('.select').querySelector('.select__search-label').style.opacity = 1;
                        //     e.currentTarget.closest('.select').querySelector('.select__search-label').style.zIndex = 1;
                        //     e.currentTarget.closest('.select').querySelector('.select__current').style.opacity = 0;
                        // }
                        // else {
                        //     e.currentTarget.closest('.select').querySelector('.select__search-label').style.opacity = 0;
                        //     e.currentTarget.closest('.select').querySelector('.select__search-label').style.zIndex = -1;
                        //     e.currentTarget.closest('.select').querySelector('.select__current').style.opacity = 1;
                        // }

                        let count = 0;
                        e.target.closest('.select').querySelectorAll('.select__item').forEach((item) => {
                            if (item.textContent.toUpperCase().indexOf(searchText.toUpperCase()) === 0) {
                                item.style.display = 'flex';
                                count = count + 1;
                            }
                            else {
                                item.style.display = 'none';
                            }
                        });
                        let countGroupItems = 0
                        let countGroupItem = null
                        e.target.closest('.select').querySelectorAll('.group-items').forEach((item) => {
                            let countItems = 0
                            item.querySelectorAll('.select__item').forEach((el) => {
                                if(el.style.display == 'flex') {
                                    countItems = countItems + 1
                                }
                            });

                            if(countItems == 0) {
                                item.style.display = 'none';
                            }
                            else {
                                item.style.display = 'block';
                                item.querySelector('.group-items-name').style.display = 'block';
                                item.classList.add('border-b')
                                countGroupItems = countGroupItems + 1
                                countGroupItem = item;
                            }
                        });

                        if(countGroupItems == 1 && countGroupItem) {
                            countGroupItem.classList.remove('border-b')
                            countGroupItem.querySelector('.group-items-name').style.display = 'none';
                        }
                        else {
                            if(countGroupItem) {
                                countGroupItem.classList.add('border-b')
                                countGroupItem.querySelector('.group-items-name').style.display = 'block';
                            }
                        }

                        if (count <= 0) {
                            e.currentTarget.closest('.select').querySelector('.select-text-no').style.display = 'block';
                        }
                        else {
                            e.currentTarget.closest('.select').querySelector('.select-text-no').style.display = 'none';
                        }
                    }
                })
            });
            //скролл боди селекта
            [].forEach.call(document.querySelectorAll('.select.select_scrollable .select__scroll-wrap'), function selectBody(el) {
                el.addEventListener('scroll', function selectBodyEl(event) {
                    let top = event.currentTarget.scrollTop;
                    let heightScroll = event.currentTarget.scrollHeight;
                    let height = event.currentTarget.offsetHeight;

                    if(top >= heightScroll - height) {
                        event.currentTarget.closest('.select__body').classList.remove('noscroll');
                    }
                    else {
                        event.currentTarget.closest('.select__body').classList.add('noscroll');
                    }
                })
            })
        });
    }

    selectInit(type = null) {
        const selectHeader = document.querySelectorAll('.select__header');
        const selectItem = document.querySelectorAll('.select__item');
        const selectResetItem = document.querySelectorAll('.select__checkbox-reset');
        const selectPopupMobileClose = document.querySelectorAll('.popup-mobile-close');
        let currentDropdown = null;

        function selectReset() {
            const select = this.closest('.select');
            if (select.classList.contains('select-input')) return;

            if (select.querySelector('input:checked')) {
                select.querySelectorAll('input:checked').forEach((item) => {
                    item.checked = false;
                });
            }

            const currentInput = select.querySelector('.select__input');
            select.classList.remove('is-selected');
            currentInput.setAttribute("value", "")
        }
        function selectToggle(e) {
            if (e.target.closest('.select-input')) return;
            if(!e.target.classList.contains('select__item-remove')) {
                if(e.target.closest('.select').classList.contains('is-search')) {
                    this.parentElement.classList.add('is-active');
                }
                else {
                    this.parentElement.classList.toggle('is-active');
                }
                if (this.parentElement.classList.contains('is-active')) {
                    currentDropdown = this.parentNode;
                } else {
                    currentDropdown = null;
                }
                let thisSelectElement = this.parentElement
                let els = document.querySelectorAll('.select');
                [].forEach.call(els, function thisSelectElementFunc(el) {
                    if(el !== thisSelectElement) {
                        el.classList.remove('is-active');

                        el.querySelector('.select__search-label').style.opacity = 0;
                        el.querySelector('.select__search-label').style.zIndex = -1;
                        el.querySelector('.select__current').style.opacity = 1;
                        el.querySelectorAll('.select__item').forEach((item) => {
                            item.style.display = 'flex';
                        });
                        el.querySelectorAll('.group-items').forEach((item) => {
                            item.style.display = 'block';
                            item.querySelector('.group-items-name').style.display = 'block';
                        });
                        el.querySelector('.select-text-no').style.display = 'none';
                    }
                });

                //srcoll active item
                function scrollIfNeeded(element, container) {
                    if (element.offsetTop < container.scrollTop) {
                        container.scrollTop = element.offsetTop;
                    } else {
                        const offsetBottom = element.offsetTop + element.offsetHeight;
                        const scrollBottom = container.scrollTop + container.offsetHeight;
                        if (offsetBottom > scrollBottom) {
                            container.scrollTop = offsetBottom - (container.offsetHeight / 2);
                        }
                    }
                }
                if (this.parentElement.classList.contains('is-active') && this.parentElement.querySelector('.select__item[active]')) {
                    scrollIfNeeded(this.parentElement.querySelector('.select__item[active]'), this.parentElement.querySelector('.select__item[active]').closest('.select__body-items'))
                }
                //srcoll active item
                if(this.closest('.select').classList.contains('is-active')) {
                    if(this.closest('.select').classList.contains('is-selected-popup-mobile') && window.innerWidth < 768) {
                        document.body.classList.add('oc-hidden');
                    }
                }
                else {
                    if(this.closest('.select').classList.contains('is-selected-popup-mobile') && window.innerWidth < 768) {
                        document.body.classList.remove('oc-hidden');
                    }
                }
            }
            else {
                let itemRemove = this.parentElement.querySelector('.select__item[data-value="'+e.target.closest('.select__item-checked').getAttribute('data-value')+'"]')
                let select = itemRemove.closest('.select');
                console.log(itemRemove);
                if (itemRemove.hasAttribute('active') && select.classList.contains('is-selected-multi')) {
                    itemRemove.removeAttribute('active');

                    const currentText = select.querySelector('.select__current');
                    const currentInput = select.querySelector('.select__input');

                    if(currentText) {
                        currentText.innerText = '';
                        currentInput.setAttribute("value", "");
                        select.querySelectorAll('.select__item').forEach((item) => {
                            if(item.hasAttribute('active')) {
                                if(currentText.textContent == '') {
                                    currentInput.setAttribute("value", item.getAttribute('data-value'));
                                    currentText.innerHTML = '<span class="select__item-checked" data-value="'+ item.getAttribute('data-value') +'">' + item.innerText + '<span class="select__item-remove"></span></span>';
                                }
                                else {
                                    currentText.innerHTML = currentText.innerHTML + '<span class="select__item-checked" data-value="'+ item.getAttribute('data-value') +'">' + item.innerText + '<span class="select__item-remove"></span></span>';
                                    currentInput.setAttribute("value", currentInput.getAttribute('value') + ',' + item.getAttribute('data-value'));
                                }
                            }
                        });

                        let widthParent = currentText.offsetWidth
                        let widthChild = 0

                        select.querySelectorAll('.select__item-checked').forEach((item) => {
                            widthChild=widthChild + item.offsetWidth

                            if(widthParent < widthChild) {
                                item.classList.add('hide')
                            }
                        });

                        let countHide = select.querySelectorAll('.select__item-checked.hide').length;
                        if(countHide > 0) {
                            currentText.innerHTML = currentText.innerHTML + '<span class="select__item-count">+' + countHide + '</span>';
                        }

                        if(currentText.textContent == '') {
                            currentText.textContent = currentText.getAttribute('data-placeholder') != '' ? currentText.getAttribute('data-placeholder') : 'Ничего не выбранно'
                        }
                    }
                }
            }
        }
        function selectChoose() {
            const select = this.closest('.select');
            if (select.classList.contains('select-input')) return;
            if (!this.hasAttribute('active')) {
                if (select.querySelector('[active]') && !select.classList.contains('is-selected-multi')) {
                    select.querySelector('[active]').removeAttribute('active');
                }
                if (select.closest('.failed')) {
                    select.closest('.failed').classList.remove('failed');
                }
                const text = this.innerText;
                const value = this.getAttribute('data-value');
                const currentText = select.querySelector('.select__current');

                if(currentText) {
                    if (currentText.classList.contains('select__current_placeholder')) {
                        currentText.classList.remove('select__current_placeholder');
                    }
                    const currentInput = select.querySelector('.select__input');
                    if (!select.classList.contains('_shopaholic-sorting')) {
                        this.setAttribute('active', '');
                    }
                    if (!select.classList.contains('is-selected-multi')) {
                        currentText.innerText = text;
                    }
                    else {
                        currentText.innerText = '';
                        select.querySelectorAll('.select__item').forEach((item) => {
                            if(item.hasAttribute('active')) {
                                if(currentText.textContent == '') {
                                    currentText.innerHTML = '<span class="select__item-checked" data-value="'+ item.getAttribute('data-value') +'">' + item.innerText + '<span class="select__item-remove"></span></span>';
                                }
                                else {
                                    currentText.innerHTML = currentText.innerHTML + '<span class="select__item-checked" data-value="'+ item.getAttribute('data-value') +'">' + item.innerText + '<span class="select__item-remove"></span></span>';
                                }
                            }
                        });
                        let widthParent = currentText.offsetWidth
                        let widthChild = 0

                        select.querySelectorAll('.select__item-checked').forEach((item) => {
                            widthChild=widthChild + item.offsetWidth

                            if(widthParent < widthChild) {
                                item.classList.add('hide')
                            }
                        });

                        let countHide = select.querySelectorAll('.select__item-checked.hide').length;
                        if(countHide > 0) {
                            currentText.innerHTML = currentText.innerHTML + '<span class="select__item-count">+' + countHide + '</span>';
                        }
                    }
                    // currentInput.value = value;
                    select.classList.add('is-selected');
                    if (!select.classList.contains('is-selected-multi')) {
                        currentInput.setAttribute("value", value);
                    }
                    else {
                        currentInput.setAttribute("value", currentInput.getAttribute('value') + ',' + value);
                    }
                    currentInput.dispatchEvent(new Event('change'));

                    select.querySelector('.select__search-label').style.opacity = 0;
                    select.querySelector('.select__search-label').style.zIndex = -1;
                    select.querySelector('.select__current').style.opacity = 1;
                    select.querySelectorAll('.select__item').forEach((item) => {
                        item.style.display = 'flex';
                    });
                    select.querySelector('.select-text-no').style.display = 'none';
                }
                currentDropdown = null;
            }
            else if (this.hasAttribute('active') && select.classList.contains('is-selected-multi')) {
                this.removeAttribute('active');

                const currentText = select.querySelector('.select__current');
                const currentInput = select.querySelector('.select__input');

                if(currentText) {
                    currentText.innerText = '';
                    currentInput.setAttribute("value", "");
                    select.querySelectorAll('.select__item').forEach((item) => {
                        if(item.hasAttribute('active')) {
                            if(currentText.textContent == '') {
                                currentInput.setAttribute("value", item.getAttribute('data-value'));
                                currentText.innerHTML = '<span class="select__item-checked" data-value="'+ item.getAttribute('data-value') +'">' + item.innerText + '<span class="select__item-remove"></span></span>';
                            }
                            else {
                                currentText.innerHTML = currentText.innerHTML + '<span class="select__item-checked" data-value="'+ item.getAttribute('data-value') +'">' + item.innerText + '<span class="select__item-remove"></span></span>';
                                currentInput.setAttribute("value", currentInput.getAttribute('value') + ',' + item.getAttribute('data-value'));
                            }
                        }
                    });

                    let widthParent = currentText.offsetWidth
                    let widthChild = 0

                    select.querySelectorAll('.select__item-checked').forEach((item) => {
                        widthChild=widthChild + item.offsetWidth

                        if(widthParent < widthChild) {
                            item.classList.add('hide')
                        }
                    });

                    let countHide = select.querySelectorAll('.select__item-checked.hide').length;
                    if(countHide > 0) {
                        currentText.innerHTML = currentText.innerHTML + '<span class="select__item-count">+' + countHide + '</span>';
                    }
                }
            }
            const currentText = select.querySelector('.select__current');
            if(currentText.textContent == '') {
                currentText.textContent = currentText.getAttribute('data-placeholder') != '' ? currentText.getAttribute('data-placeholder') : 'Ничего не выбранно'
            }
            if (!select.classList.contains('is-selected-multi')) {
                select.classList.remove('is-active');

                if(select.classList.contains('is-selected-popup-mobile') && window.innerWidth < 768) {
                    document.body.classList.remove('oc-hidden');
                }
            }
        }
        if(!type || type == 'reInit') {
            selectItem.forEach((item) => {
                if (item.closest('.select-input')) return;
                if (!item.closest('.select').classList.contains('select_init')) {
                    item.addEventListener('click', selectChoose);
                }
            });
        }
        if(!type) {
            selectHeader.forEach((item) => {
                if (item.closest('.select-input')) return;
                if (!item.closest('.select').classList.contains('select_init')) {
                    item.addEventListener('click', selectToggle);
                    item.closest('.select').classList.add('select_init');
                }
            });
            selectPopupMobileClose.forEach((item) => {
                item.addEventListener('click', selectToggle);
            });
            selectResetItem.forEach((item) => {
                if (item.closest('.select-input')) return;
                item.addEventListener('click', selectReset);
            });
        }
        if(!type) {
            document.querySelectorAll('.select_scrollable .select__body').forEach((i) => {
                if (i.closest('.select-input')) return;
                if (i.scrollHeight > i.clientHeight) {
                    i.classList.add('noscroll');
                }
            });

            document.addEventListener('click', (e) => {
                if (e.target.closest('.select-input')) return;
                if (currentDropdown && e.target !== currentDropdown && !currentDropdown.contains(e.target)) {
                    currentDropdown.classList.remove('is-active');
                    currentDropdown = null;

                    [].forEach.call(document.querySelectorAll('.select'), function selectHeader(el) {
                        el.querySelector('.select__search-label').style.opacity = 0;
                        el.querySelector('.select__search-label').style.zIndex = -1;
                        el.querySelector('.select__current').style.opacity = 1;
                        el.querySelectorAll('.select__item').forEach((item) => {
                            item.style.display = 'flex';
                        });
                        el.querySelectorAll('.group-items').forEach((item) => {
                            item.style.display = 'block';
                            item.querySelector('.group-items-name').style.display = 'block';
                        });
                        el.querySelector('.select-text-no').style.display = 'none';
                    });
                }
            });
        }
    }
}();
